import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationPopupComponent } from 'src/app/shared/component/confirmation-popup/confirmation-popup.component';
import { Context } from 'src/app/shared/models/context';
import { Leave, Message, PrivilegeType } from 'src/app/shared/models/domain';
import { AppearanceService } from 'src/app/shared/services/appearance.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { ManageRegularComponent } from '../manage-regular/manage-regular.component';
import { DataService } from 'src/app/shared/services/data.service';

@Component({
  selector: 'app-regular-list',
  templateUrl: './regular-list.component.html',
  styleUrls: ['./regular-list.component.scss']
})
export class RegularListComponent implements OnInit {
  public regulars: Leave[] = [];
  public context: Context;
  public status: string = 'APPLIED';
  public tempStatus: string = 'APPLIED';
  public fromDate: string;
  public toDate: string;
  public isLoading: boolean = true;
  public privilege: PrivilegeType;
  public statuses: string[] = [];
  public currentTab: string = 'REGULAR';

  constructor(
    private authService: AuthService,
    private commonService: CommonService,
    private appearanceService: AppearanceService,
    private modalService: NgbModal,
    private datePipe: DatePipe,
    private dataService: DataService
  ) { }

  ngOnInit(): void {
    this.dataService.privilege().subscribe(privilege => { this.privilege = this.commonService.getPrivileges(privilege) });
    this.fromDate = this.datePipe.transform(this.commonService.adjustDateByDays(-30), 'yyyy-MM-dd');
    this.toDate = this.datePipe.transform(this.commonService.adjustDateByDays(30), 'yyyy-MM-dd');
    this.context = this.authService.getContextData();
    if (this.context && this.context?.companyId) {
      this.getRegular();
    }
    this.getRegularStatuses();
  }

  private getRegular(clear: boolean = true) {
    if (this.context?.employeeId) {
      if (clear) {
        this.isLoading = true;
        this.regulars = [];
      }
      if (!this.fromDate || !this.toDate) {
        this.commonService.setToastr(500, "Both \"From Date\" and \"To Date\" are required to proceed.")
        return;
      }
      const fromDate = this.datePipe.transform(this.fromDate, 'dd-MM-yyyy');
      const toDate = this.datePipe.transform(this.toDate, 'dd-MM-yyyy');
      this.appearanceService.getRegulars(this.context?.employeeId, fromDate, toDate, this.status).subscribe({
        next: (regulars: Leave[]) => {
          this.regulars = regulars.sort((a, b) => a.id - b.id);
          this.isLoading = false;
        },
        error: (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.commonService.setToastr(500, error?.error?.name || error.error);
        }
      });
    } else {
      this.isLoading = false;
    }
  }

  private getRegularStatuses() {
    this.appearanceService.getStatus().subscribe((statuses) => {
      this.statuses = statuses.filter(s => s !== 'COMPLETED');;
    });
  }



  public deleteRegualar(regular: Leave, index: number) {
    if (!this.privilege.canDelete) return;
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.title = "Regular deletion";
    modalRef.componentInstance.prefixMessage = "Are you sure you want to delete";
    modalRef.componentInstance.message = "Regular";
    modalRef.componentInstance.label = 'regular';
    modalRef.result.then((isConfirmed: boolean) => {
      if (isConfirmed) {
        regular.isDeleteInProgress = true;
        this.appearanceService.tocheckIfRegularIsApplicable(regular.id).subscribe((check: boolean) => {
          if (!check) {
            this.commonService.setToastr(500, 'Regular cannot be cancelled.');
            regular.isDeleteInProgress = false;
          } else {
            regular.status = "CANCELLED";
            this.appearanceService.updateRegular(regular.id, regular).subscribe({
              next: (response: Leave) => {
                if (response) {
                  this.commonService.setToastr(200, 'You have successfully cancelled your regularization!');
                  this.regulars.splice(index, 1);
                  this.getRegular(false);
                  regular.isDeleteInProgress = false;
                } else {
                  this.commonService.setToastr(500, 'Unable to complete the action. Please try again.');
                  regular.isDeleteInProgress = false;
                }
              },
              error: (error: HttpErrorResponse) => {
                this.commonService.setToastr(500, error?.error?.name || error.error);
                regular.isDeleteInProgress = false;
              },
            });
          }
        })
      }
    });
  }

  public upsertRegular(regular?: Leave) {
    if (!this.privilege.canEdit) return;
    const modalRef = this.modalService.open(ManageRegularComponent, { size: 'lg', backdrop: 'static' });
    modalRef.componentInstance.regular = regular;
    modalRef.componentInstance.context = this.context;
    modalRef.result.then((response: Leave) => {
      if (response.id) {
        this.getRegular(false);
      }
    });
  }

  public onStatusChange() {
    this.getRegular(false);
    this.tempStatus = this.status;
  }
}

